let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3wW1N")).then(() => parcelRequire('eKOIc'));